// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KnYJJJHti0njfqD9VoRl{flex-direction:column;height:100%;padding:16px 24px 24px;display:flex;overflow-y:auto}.w1yGxqendGwIpOQ0uL6l{flex-direction:column;gap:12px;margin-top:-2px;margin-bottom:-3px;display:flex}.pTnpppi02JsU4QFJxVU_{word-wrap:break-word;white-space:pre-wrap;max-height:464px;overflow-y:auto}.c0buRoL4Ho0IXnfviSp1{overflow-x:hidden;overflow-y:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `KnYJJJHti0njfqD9VoRl`,
	"titleWrap": `w1yGxqendGwIpOQ0uL6l`,
	"stringDataContainer": `pTnpppi02JsU4QFJxVU_`,
	"infoBlockWrap": `c0buRoL4Ho0IXnfviSp1`
};
export default ___CSS_LOADER_EXPORT___;
